import { render, staticRenderFns } from "./MyAccountCard.vue?vue&type=template&id=4fb99515&scoped=true&"
import script from "./MyAccountCard.vue?vue&type=script&lang=ts&"
export * from "./MyAccountCard.vue?vue&type=script&lang=ts&"
import style0 from "./MyAccountCard.vue?vue&type=style&index=0&id=4fb99515&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb99515",
  null
  
)

export default component.exports